import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import RegisterForm from './component/RegisterForm/RegisterForm.jsx';
import LoginForm from './component/LoginForm/LoginForm.jsx';
import Dashboard from './component/dashboard/dashboard.jsx';
import GroupDetails from './component/dashboard/sections/GroupDetails.jsx';
import GroupSummaryModal from './component/dashboard/modals/GroupSummaryModal.jsx';
import Home from './component/Landingpage/Home.jsx';

function App() {
  return (
    
   <Router>
      <div>
        

        {/* Route definitions - Controls which component shows on which URL */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/registerform" element={<RegisterForm />} />
          <Route path="/login" element={<LoginForm /> } />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/group/:groupId" element={<GroupDetails />} />
          <Route path="/summary/:groupId" element={<GroupSummaryModal />} />
        </Routes>
        
        
      </div>
      
    </Router>
    
  );
    
}

export default App;
